import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PortalTimeoutService } from '../../services/portal-timeout/portal-timeout.service';

@Injectable()
export class PortalTimeoutInterceptor implements HttpInterceptor {
  constructor(private timeoutService: PortalTimeoutService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.timeoutService.resetTimeout();
    return next.handle(request);
  }
}
